/**
 * DENET — WhatsApp düğmesi
 *
 * Üç iş yapar:
 *  - Sayfa biraz kaydırılınca belirir. Açılışta belirirse okumaya başlamadan
 *    rahatsız ediyor.
 *  - Mesai dışında "kapalıyız" der ama kaybolmaz. Cevapsız kalan bir WhatsApp,
 *    hiç olmamasından kötü — insan yazmadan önce bilmeli.
 *  - Balon KENDİLİĞİNDEN AÇILMAZ (marka kuralı: site kullanıcıyı bölmez).
 *    Düğmeye ilk tıklamada açılır ve hazır konuları gösterir; ikinci tıklama
 *    ya da bir konu seçimi WhatsApp'a götürür. Dokunmatik cihazda balon
 *    atlanır, düğme doğrudan WhatsApp'ı açar.
 */

import { DenetElement, define, media } from '@denet/core';

const DISMISSED = 'denet:wa:bubble';

class DnWhatsApp extends DenetElement {
  mounted() {
    this.link = this.ref('link');
    this.bubble = this.ref('bubble');
    this.threshold = Number(this.dataset.scroll) || 0;

    this.#applyHours();

    const reveal = () => {
      if (window.scrollY < this.threshold) return;
      this.hidden = false;
      this.classList.add('is-in');
      window.removeEventListener('scroll', reveal);
    };

    if (this.threshold === 0) {
      this.hidden = false;
      this.classList.add('is-in');
    } else {
      window.addEventListener('scroll', reveal, { passive: true, signal: this.signal });
      reveal();
    }

    this.ref('close')?.addEventListener('click', () => {
      this.bubble.hidden = true;
      try { sessionStorage.setItem(DISMISSED, '1'); } catch { /* gizli sekme */ }
    }, { signal: this.signal });

    /* İlk tıklama balonu açar; balon açıkken ya da kapatılmışsa bağlantı
       normal çalışır. Balon yalnız kullanıcının isteğiyle görünür. */
    this.link?.addEventListener('click', (event) => {
      if (!this.bubble || !this.bubble.hidden || !media.pointerFine) return;
      try { if (sessionStorage.getItem(DISMISSED)) return; } catch { /* yoksay */ }
      event.preventDefault();
      this.bubble.hidden = false;
    }, { signal: this.signal });

    /* Balonun dışına tıklanınca kapanır: ürünün üstünde asılı kalmasın. */
    document.addEventListener('click', (event) => {
      if (!this.bubble || this.bubble.hidden) return;
      if (event.target instanceof Node && this.contains(event.target)) return;
      this.bubble.hidden = true;
    }, { signal: this.signal });
  }

  /* Mesai dışındaysa etiketi ve hazır mesajı değiştirir. */
  #applyHours() {
    const open = Number(this.dataset.open);
    const close = Number(this.dataset.close);
    const days = (this.dataset.days || '')
      .split(',').map((d) => Number(d.trim())).filter(Boolean);

    if (!days.length || Number.isNaN(open) || Number.isNaN(close)) return;

    const now = new Date();
    /* JS'te pazar 0; bizim ayarda pazartesi 1 … pazar 7. */
    const day = now.getDay() === 0 ? 7 : now.getDay();
    const hour = now.getHours();
    const isOpen = days.includes(day) && hour >= open && hour < close;

    this.classList.toggle('is-closed', !isOpen);
    if (!isOpen) {
      this.ref('dot')?.setAttribute('data-state', 'closed');
      const t = this.ref('bubbleTitle');
      const x = this.ref('bubbleText');
      if (t) t.textContent = 'Şu an mesai dışındayız';
      if (x) x.textContent = `Yazın, ${open}:00'dan itibaren dönüş yapalım.`;
    }
  }

}

define('dn-whatsapp', DnWhatsApp);
